import { Skeleton } from "@mui/material"
import { Suspense, useEffect } from "react"
import { useSecurityDialog } from "../SecurityDialogProvider"
import { SecurityDialog } from "../common"
import { useLoadingDialog } from "./useLoadingDialog"

export interface LoadingDialogProps {
  goHome: () => void
  open: boolean
}

export const LoadingDialog = ({ open, ...props }: LoadingDialogProps) => {
  return (
    <SecurityDialog open={open}>
      <Suspense
        fallback={<Skeleton variant="rectangular" height="400px" width="100%" />}
      >
        <LoadingDialogInner {...props} />
      </Suspense>
    </SecurityDialog>
  )
}

export const LoadingDialogInner = ({ goHome }: Omit<LoadingDialogProps, "open">) => {
  const { hasAccess } = useLoadingDialog()
  const security = useSecurityDialog()

  useEffect(() => {
    if (hasAccess) {
      security.pinDialog({ goHome })
    } else {
      security.activatePrivateAccessDialog({ goHome })
    }
  }, [hasAccess, goHome, security])
  return <Skeleton variant="rectangular" height="400px" width="100%" />
}
